<template>
  <b-card>
    <b-form @submit.prevent="save">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group label="Evento" label-for="evento">
            <v-select
              id="evento"
              v-model="eventParticipant.evento"
              :options="eventos"
              label="nome"
              :reduce="(evento) => evento"
              placeholder="Selecione o evento"
              required
            >
              <template #no-options>
                <div class="text-muted">Nenhum evento encontrado</div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Registro" label-for="registro">
            <v-select
              id="registro"
              v-model="eventParticipant.registro"
              :options="registros"
              label="nome"
              :reduce="(reg) => reg"
              placeholder="Selecione o registro"
              required
            >
              <template #no-options>
                <div class="text-muted">Nenhum registro encontrado</div>
              </template>
            </v-select>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6">
          <b-form-group label="Data de Inscrição" label-for="inscritoEm">
            <flat-pickr
              id="inscritoEm"
              v-model="eventParticipant.inscritoEm"
              class="form-control"
              :config="dateTimeConfig"
              placeholder="Selecione a data de inscrição"
              required
            />
          </b-form-group>
        </b-col>

        <ButtonsFormVue
          :permission-insert="verificarPermissao('ROLE_ADMIM_INSERIR')"
          :permission-edit="verificarPermissao('ROLE_ADMIM_ATUALIZAR')"
          :disable-form="false"
          @save="save"
          @cancel="cancel"
        />
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import { mapState } from 'vuex';
import {
  BRow,
  BCol,
  BFormGroup,
  BCard,
  BForm,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import ButtonsFormVue from '@/layouts/components/ButtonsForm.vue';
import { verificarPermissao } from '@/auth/utils';

export default {
  name: 'EventParticipantForm',
  components: {
    BRow,
    BCol,
    BFormGroup,
    BCard,
    BForm,
    vSelect,
    flatPickr,
    ButtonsFormVue,
  },
  data() {
    return {
      verificarPermissao,
      dateTimeConfig: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
        time_24hr: true,
        locale: 'pt',
      },
      eventos: [],
      registros: [],
    };
  },
  computed: {
    ...mapState('eventParticipantSettingsModule', {
      eventParticipant: (state) => state.eventParticipant,
    }),
  },
  created() {
    this.loadDependencies();
  },
  methods: {
    async loadDependencies() {
      try {
        // TODO: Replace with actual API calls
        // this.eventos = await this.$http.get('/api/eventos');
        // this.registros = await this.$http.get('/api/registros');
      } catch (error) {
        console.error('Error loading dependencies:', error);
      }
    },
    save() {
      const payload = {
        ...this.eventParticipant,
        evento: { id: this.eventParticipant.evento?.id },
        registro: { id: this.eventParticipant.registro?.id },
      };

      if (this.eventParticipant.id) {
        this.$store.dispatch('eventParticipantSettingsModule/edit', payload);
      } else {
        this.$store.dispatch('eventParticipantSettingsModule/insertNew', payload);
      }
    },
    cancel() {
      this.$emit('cancelar');
      this.$store.dispatch('eventParticipantSettingsModule/reset');
    },
  },
};
</script>
